<template>

    <section class="w-100 h-100">

        <!-- Loading -->
        <loading/>

        <h1 id="header">Blog Module</h1>

        <!-- Back To -->
        <template v-if="formaction === 'update'">
            <back-to
                :urlreference="moduledefaultindex" 
            />
        </template>

        <!-- Form Structure -->
        <div class="d-flex flex-column">

            <form @submit.prevent="sendData(formaction, 'blogpost')" class="form-blog" action="" method="post" aria-describedby="Create Post" enctype="multipart/form-data" autocomplete="on">

                <!-- Primary Image -->
                <fieldset class="primary-image mb-3">

                    <header class="d-flex flex-row justify-content-between">

                        <div class="legendbase order-1">
                            <legend>Primary Image</legend>
                            <small>Indicate for Post Background Image</small>
                        </div>

                        <div class="baseaction order-2">
                            <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                        </div>
                        
                    </header>
                    
                    <div class="fieldsetcontent d-none">

                        <!-- <div class="mb-3 primary-image primary-image-filealt" data-inputorder="1">
                            <div class="d-flex flex-row justify-content-between">
                                <label for="filealt" class="form-label">File Info</label>
                                <button type="button" class="btn btn-secondary btnselectimage order-2" @click="showModal($event, 'baseselectimage')" data-imgselect="primaryimage">Images</button>
                            </div>
                            <input @focusin="inputValidation($event, 'filealt')" @focusout="inputValidation($event, 'filealt')" type="text" name="filealt" v-model="filealt" class="form-control filealt" id="filealt" placeholder="Please inform the alt from file">
                        </div> -->
        
                        <div class="mb-3 primary-image primary-image-file" data-inputorder="2">
                            <div class="d-flex flex-row justify-content-between">
                                <label for="file" class="form-label order-1">File</label>
                                <button type="button" class="btn btn-secondary btnselectimage order-2" @click="showModal($event, 'baseselectimage')" data-imgselect="primaryimage">Images</button>
                            </div>
                            <input @change="multipleFileData($event, 'primaryimage')" class="form-control file" name="file" type="file" id="file" accept="image/*" ref="inputfile">
                        </div>

                        <div @click="removeFile($event, 'primaryimage')" class="mb-3 primary-image-render d-flex flex-row" style="flex-wrap:wrap;">
                        </div>

                    </div>
                
                </fieldset>

                <!-- Post Media -->
                <fieldset class="postmedia mb-3">

                    <header class="d-flex flex-row justify-content-between">

                        <div class="legendbase order-1">
                            <legend>Post Media</legend>
                            <small>Recommended for all images related to the blog post</small>
                        </div>

                        <div class="baseaction order-2">
                            <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                        </div>
                        
                    </header>

                    <div class="fieldsetcontent d-none">

                        <div 
                            class="mb-3 postmedia postmedia-files" 
                            data-inputorder="1"
                            @click="removeImageFromSelectDataList($event)"
                        >
                            <div class="d-flex flex-row justify-content-between">
                                <label for="files" class="form-label">File</label>
                                <button type="button" class="btn btn-secondary btnselectimage order-2" @click="showModal($event, 'baseselectimage')" data-imgselect="postmedia">Images</button>
                            </div>
                            <!-- Posible add multiple on input file -->
                            <input @change="multipleFileData($event, 'postmedia')" class="form-control files" name="files" type="file" id="files" accept="image/*" ref="inputfilemultiple">
                        </div>
    
                        <div 
                            class="mb-3 postmedia postmedia-link d-flex flex-column" 
                            data-inputorder="2"
                        >
                            <label for="linkvideo order-1" class="form-label">Link of Video</label>
                            <small class="order-2"><b>You can add more than one link separating by comma</b></small> 
                            <input @focusin="inputValidation($event, 'linkvideo')" @focusout="inputValidation($event, 'linkvideo')" type="text" name="linkvideo" v-model="linkvideo" class="form-control linkvideo order-3" id="linkvideo" placeholder="Please inform the link">
                        </div>
    
                        <div @click="removeFile($event, 'postmedia')" class="mb-3 postmedia-render d-flex flex-row" style="flex-wrap:wrap;">
                        </div>

                    </div>
    
                </fieldset>
    
                <!-- Post Copy -->
                <fieldset class="postcopy mb-3">

                    <header class="d-flex flex-row justify-content-between">

                        <div class="legendbase order-1">
                            <legend>Post Copy</legend>
                            <small>Recommended for all texts related to the blog post</small>
                        </div>

                        <div class="baseaction order-2">
                            <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                        </div>
                        
                    </header>
    
                    <div class="fieldsetcontent d-none">
                        <div class="my-2 postcopy">
    
                            <div class="mb-3 postcopy postcopy-title" data-inputorder="1">
                                <label for="postcopy-title" class="form-label">Title</label>
                                <input @focusin="inputValidation($event, 'postcopy-title')" @focusout="inputValidation($event, 'postcopy-title')" type="text" maxlength="300" name="postcopy-title" v-model="title" class="form-control" id="postcopy-title" placeholder="Please inform the Title">
                            </div>
    
                            <div class="mb-3 postcopy postcopy-subtitle" data-inputorder="2">
                                <label for="postcopy-subtitle" class="form-label">Subtitle</label>
                                <input @focusin="inputValidation($event, 'postcopy-subtitle')" @focusout="inputValidation($event, 'postcopy-subtitle')" type="text" maxlength="300" name="postcopy-subtitle" v-model="subtitle" class="form-control" id="postcopy-subtitle" placeholder="Please inform the Subtitle">
                            </div>
        
                            <!---<div class="mb-3 postcopy postcopy-description" data-inputorder="3">
                                <label for="postcopy-description" class="form-label">Descrição</label>
                                <textarea @focusin="inputValidation($event, 'postcopy-description')" @focusout="inputValidation($event, 'postcopy-description')" class="form-control" v-model="description" name="postcopy-description" id="postcopy-description" aria-label="post description" placeholder="Please inform the description">
                                    {{ description.trim() }}
                                </textarea>
                            </div>-->

                            <div class="mb-3" data-inputorder="3">

                                <span class="form-label">Descrição</span>

                                <!--VueQuill provides 3 pre-configured toolbar options essential, minimal, full, and "" to use default options.-->
                                <!---
                                    
                                    //Quill Editor Events
                                    :content="editorData"
                                    reference: https://vueup.github.io/
                                    @focus="(quill) => console.log('focus', quill)"
                                    @blur="(quill) => console.log('blur', quill)"
                                    @ready="(quill) => console.log('ready', quill)"
                                    @selection-change="({ range, oldRange, source }) => console.log('selection-change', range, oldRange, source)"
                                    @text-change="({ delta, oldContent, source }) => console.log('text-change', delta, oldContent, source)"
                                    @editor-change="(eventName) => console.log({editorchange: eventName.oldContents})"
                                
                                -->
                                <QuillEditor
                                    ref="quilltexteditor"
                                    toolbar="essential"
                                    theme="snow"
                                    placeholder="Your Post Content"
                                    @focusin="getEditorDescriptionData()"
                                    @focusout="getEditorDescriptionData()"                                  
                                />   

                            </div>
        
                        </div>
                    </div>
    
                </fieldset>

                <!-- Post SEO -->
                <fieldset class="postseo mb-3">

                    <header class="d-flex flex-row justify-content-between">

                        <div class="legendbase order-1">
                            <legend>Post SEO</legend>
                            <small>Add data for use to SEO</small>
                        </div>

                        <div class="baseaction order-2">
                            <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                        </div>
                        
                    </header>
    
                    <div class="fieldsetcontent d-none">
                        <div class="my-2 postseo">
    
                            <div class="mb-3 postseo postseo-keywords" data-inputorder="1">
                                <label for="postseo-keywords" class="form-label">Keywords</label>
                                <input @focusin="inputValidation($event, 'postseo-keywords')" @focusout="inputValidation($event, 'postseo-keywords')" type="text" maxlength="300" name="postseokeywords" v-model="keywords" class="form-control" id="postseo-keywords" placeholder="Please inform the Keywords">
                            </div>
    
                            <div class="mb-3 postseo postseo-shortdescription" data-inputorder="2">
                                <label for="postseo-shortdescription" class="form-label">Description</label>
                                <input @focusin="inputValidation($event, 'postseo-shortdescription')" @focusout="inputValidation($event, 'postseo-shortdescription')" type="text" maxlength="300" name="postseoshortdescription" v-model="shortdescription" class="form-control" id="postseo-shortdescription" placeholder="Please inform the Description">
                            </div>

                            <div class="mb-3 postseo postseo-canonicalurl" data-inputorder="3">
                                <label for="postseo-canonicalurl" class="form-label">Canonical URL</label>
                                <input @focusin="inputValidation($event, 'postseo-canonicalurl')" @focusout="inputValidation($event, 'postseo-canonicalurl')" type="text" maxlength="400" name="postseocanonicalurl" v-model="canonicalurl" class="form-control" id="postseo-canonicalurl" placeholder="Please inform the Canonical Url">
                            </div>
        
                        </div>
                    </div>
    
                </fieldset>

                <!-- Post Associated -->
                <fieldset v-if="authorization" class="postassociatedfieldset mb-3">

                    <header class="d-flex flex-row justify-content-between">

                        <div class="legendbase order-1">
                            <legend>Associated Post</legend>
                            <small>Indicated category(s), subcategory(s) and store for the post</small>
                        </div>

                        <div class="baseaction order-2">
                            <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                        </div>
                        
                    </header>

                    <div class="fieldsetcontent postassociatedfieldsetcontent d-none">
                        <div class="postassociated-base my-3">

                            <!-- Post Category -->
                            <div class="postassociated postassociated-category d-flex flex-column mb-3" style="background-color:#e8e8e8;">
    
                                <div class="d-flex flex-row justify-content-between order-1">
    
                                    <div class="d-flex flex-column justify-content-start mb-3 order-1">
                                        <span class="order-1">Category</span>
                                        <small class="order-2"><b>You can add more than one category separating by comma</b></small>    
                                    </div>
                            
                                    <!-- <div class="btnactions-category order-3">
                                        <button type="button" class="btn btn-primary order-1 btntrigger-category" @click="showInput('category-input', 'category-radio-base', $event)" ref="btntriggercategory">Add</button>
                                    </div> -->
            
                                </div>
                              
                                <div class="postassociated-category-base order-2">
    
                                    <!-- <div class="mb-3 postcategory category-input d-flex flex-row justify-content-between align-items-end col-12 p-0 m-0 d-none" data-inputorder="1">
                                        
                                        <div class="order-1 col-8 p-0 m-0">
                                            <label for="category-input" class="form-label">New Category</label>
                                            <input type="text" name="category-input" v-model="category" class="form-control category-input" id="category-input" placeholder="Please inform the Category">
                                        </div>
                                        
                                        <div class="order-2 col-2 p-0 m-0 d-flex flex-column align-items-end">
    
                                            <button type="button" class="btn btn-primary" @click="sendData('insert', 'category', category, 'category-input')">Create</button>
    
                                        </div>
                                        
                                    </div> -->
    
                                    <div class="postcategory category-radio-base d-flex flex-column" data-inputorder="1">

                                        <template v-if="Object.values(categorylist).length > 0">

                                            <span class="order-1 my-3">Post Category List</span>

                                            <div class="category-radio-inputs d-flex flex-row justify-content-between order-2" style="flex-wrap:wrap;">
    
                                                <div v-for="(value, index) in categorylist" :key="value.id" class="form-check mb-3 category-radio-input">
                                                  
                                                    <span @click="choosedAssociatedPost($event, postcategorieschoose, 'data-categoryid')" class="postcategories chooseitemblogpost" :data-categoryid="value.id" :id="`postcategories_${value.id}`">{{ value.name }}</span>
                                                 
                                                </div>
        
                                            </div>

                                        </template>
    
                                        <template v-else>

                                            <span>Favor criar Categoria</span>

                                        </template>
                                        
                                    </div>
    
                                </div>
    
                            </div>
    
                            <!-- Post Subcategory -->
                            <!-- <div class="postassociated postassociated-subcategory d-flex flex-column mb-3" style="background-color:#e7e7e7;">
    
                                <div class="d-flex flex-row justify-content-between order-1">
    
                                    <div class="d-flex flex-column justify-content-start mb-3 order-1">
                                        <span class="order-1">Subcategory</span>
                                        <small class="order-2"><b>You can add more than one subcategory separating by comma</b></small>
                                    </div>
    
                                    <div class="btnactions-subcategory order-3">
                                        <button type="button" class="btn btn-primary order-1 btntrigger-subcategory" @click="showInput('subcategory-input', 'subcategory-radio-base', $event)" ref="btntriggersubcategory">Add</button>
                                    </div>
            
                                </div>
                              
                                <div class="postassociated-subcategory-base order-2">
    
                                    <div class="mb-3 postsubcategory subcategory-input d-flex flex-row justify-content-between align-items-end col-12 p-0 m-0 d-none" data-inputorder="1">
                                        
                                        <div class="order-1 col-8 p-0 m-0">
                                            <label for="subcategory-input" class="form-label">New Subcategory</label>
                                            <input type="text" name="subcategory-input" v-model="subcategory" class="form-control" id="subcategory-input" placeholder="Please inform the Subcategory">
                                        </div>
                                        
                                        <div class="order-2 col-2 p-0 m-0 d-flex flex-column align-items-end">
    
                                            <button type="button" class="btn btn-primary" @click="sendData('insert', 'subcategory', subcategory, 'subcategory-input')">Create</button>
    
                                        </div>
                                        
                                    </div>
    
                                    <div class="postsubcategory subcategory-radio-base d-flex flex-column d-none" data-inputorder="1">
    
                                        <template v-if="Object.values(subcategorylist).length > 0">

                                            <span class="order-1 my-3">Post Subcategory List</span>
    
                                            <div class="subcategory-radio-inputs d-flex flex-row justify-content-between order-2">
        
                                                <div v-for="(value, index) in subcategorylist" :key="value.id" class="form-check mb-3 subcategory-radio-input">                            
                                                    <span @click="choosedAssociatedPost($event, postsubcategorieschoose, 'data-subcategoryid')" class="postsubcategories chooseitemblogpost" :data-subcategoryid="value.id" :id="`postsubcategories_${value.id}`">{{ value.name }}</span>
                                                </div>
        
                                            </div>

                                        </template>

                                        <template v-else>

                                            <span>Favor add Subcategorias</span>

                                        </template>
                                        
                                    </div>
    
                                </div>
    
                            </div> -->
    
                            <!-- Post Stores -->
                            <div class="postassociated postassociated-stores d-flex flex-column mb-3" style="background-color:#e7e7e7;">

                                <div class="poststore store-radio-base d-flex flex-column" data-inputorder="1">

                                    <template v-if="Object.values(storecompanylist).length > 0">

                                        <span class="order-1 my-3">Post Store List</span>

                                        <div class="store-radio-inputs d-flex flex-row justify-content-between order-2">
    
                                            <div v-for="(value, index) in storecompanylist" :key="value.id" class="form-check mb-3 store-radio-input">                                      
                                                <span @click="choosedAssociatedPost($event, poststorieschoose, 'data-storeid')" class="poststories chooseitemblogpost" :data-storeid="value.id" :id="`poststories_${value.id}`">{{ value.name }}</span>
                                            </div>
    
                                        </div>

                                    </template>

                                    <template v-else>

                                        <span>Favor add Store</span>

                                    </template>

                                </div>
    
                                <!-- <div class="d-flex flex-row justify-content-between order-1">
    
                                    <div class="d-flex flex-column justify-content-start mb-3 order-1">
                                        <span class="order-1">Stores</span>
                                        <small class="order-2"><b>You can add more than one store separating by comma</b></small>
                                    </div>
    
                                    <div class="btnactions-stores order-2">
                                        <button type="button" class="btn btn-primary order-1" @click="showInput('store-input', 'store-radio-base', $event)" ref="btntriggerstoreassociated">Add</button>
                                    </div>
            
                                </div> -->
                              
                                <!-- <div class="postassociated-stores-base order-2">
    
                                    <div class="mb-3 poststore store-input d-flex flex-row justify-content-between align-items-end col-12 p-0 m-0 d-none" data-inputorder="1">
                                        
                                        <div class="order-1 col-8 p-0 m-0">
    
                                            <label for="store-input" class="form-label">New Store</label>
    
                                            <div class="col-8 p-0 m-0 d-flex flex-row inputbasestore" id="inputbasestore">
    
                                                <input type="text" name="store-input" v-model="store" class="form-control col-5" id="store-input" placeholder="Please inform the Store">
                                                <input type="text" name="store-input-link" v-model="storelink" class="form-control col-5" id="store-input-link" placeholder="Please inform the Store Link">
    
                                            </div>
                                           
                                        </div>
                                        
                                        <div class="order-2 col-2 p-0 m-0 d-flex flex-column align-items-end">
    
                                            <button type="button" class="btn btn-primary" @click="sendData('insert', 'storiescompanys', [store, storelink], ['store-input', 'store-input-link', 'inputbasestore'])">Create</button>
    
                                        </div>
                                        
                                    </div>
    
                                    <div class="poststore store-radio-base d-flex flex-column d-none" data-inputorder="1">

                                        <template v-if="Object.values(storecompanylist).length > 0">

                                            <span class="order-1 my-3">Post Store List</span>
    
                                            <div class="store-radio-inputs d-flex flex-row justify-content-between order-2">
        
                                                <div v-for="(value, index) in storecompanylist" :key="value.id" class="form-check mb-3 store-radio-input">                                      
                                                    <span @click="choosedAssociatedPost($event, poststorieschoose, 'data-storeid')" class="poststories chooseitemblogpost" :data-storeid="value.id" :id="`poststories_${value.id}`">{{ value.name }}</span>
                                                </div>
        
                                            </div>

                                        </template>
    
                                        <template v-else>

                                            <span>Favor add Store</span>

                                        </template>
    
                                    </div>
    
                                </div> -->
    
                            </div>
    
                        </div>
                    </div>
                  
                </fieldset>
    
                <button type="submit" class="btn btn-primary float-end my-3" :disabled="disabled">{{ btntext }}</button>
    
            </form>

        </div>

        <!-- Modal for Select Image -->
        <modal
            title="Select Image"
            classname="baseselectimage"
        >

            <template #modalcontent>

                <!-- Media List -->
                <media-list
                    :allmediafiles="allmediafiles"
                    @choose-image="chooseImage($event)"
                />

            </template>

        </modal>

        <!-- Blog Post List -->
        <div v-if="formaction === 'insert'" class="d-flex flex-column w-100 h-100">

            <!-- Check Blog List -->
            <template v-if="Object.values(alldata).length > 0">

                <h2 class="order-1">Blog Posts</h2>

                <!-- Module Actions -->
                <module-action
                    :csrftolken="csrftolken"
                    :alldata="blogpostlistdb"
                    @dynamic-data="getDynamicDataFromModuleAction($event)"
                    :orderurl="orderurl"
                    :searchurl="searchurl"
                    classname="order-2"
                >

                    <template #custom_action>
                    </template>

                </module-action>

                <!-- Blog List Render-->
                <table-element :classname="['table-striped', 'order-3', 'my-3']">

                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">User Created</th>
                            <th scope="col">Title</th>
                            <th scope="col">Category</th>
                            <th scope="col">Subcategory</th>
                            <th scope="col">Stores</th>
                            <th scope="col">Active</th>
                            <th scope="col">Created</th>
                            <th scope="col">Updated</th>
                            <!-- <th scope="col">SoftDelete</th> -->
                            <th scope="col">Actions</th>
                        </tr>
                    </template>

                    <!-- Tbody -->
                    <template #tbody>

                        <tr v-for="(value, index) in alldata" :key="value.id" :data-referid="index" :data-postid="value.id" :data-userid="value.user_id">
                            <th scope="row">{{ value.id }}</th>
                            <td>{{ value.user_name }}</td>
                            <td>{{ value.title }}</td>
                            <td>{{ getDataFromBlogPostsAssociated(value.category) }}</td>
                            <td>{{ getDataFromBlogPostsAssociated(value.subcategory) }}</td>
                            <td>{{ getDataFromBlogPostsAssociated(value.stores) }}</td>
                            <td>
                                <button @click="buttonsAction($event, 'active')" class="btn btn-light" type="button" data-action="1">
                                    {{ value.active }}
                                </button>
                            </td>
                            <td>{{ value.created_at }}</td>
                            <td>{{ value.updated_at !== null ? value.updated_at : '' }}</td>
                            <td>{{ value.deleted_at !== null ? value.deleted_at : '' }}</td>
                            <td class="d-flex flex-row justify-content-between">
                                <button class="btn btn-primary" @click="buttonsAction($event, 'edit')" data-action="2">Edit</button>
                                
                                <!--
                                <template v-if="value.deleted_at === null">
                                    <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'softdelete')" data-action="3">Delete</button>
                                </template>
                                
                                <template v-else>
                                    <button class="btn btn-info" type="button" @click="buttonsAction($event, 'restore')" data-action="4">Restore</button>
                                </template> -->
                                
                                <div v-if="parseInt(value.user_rule) === 1">
                                    <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'remove')" data-action="5">Remove</button>
                                </div>

                            </td>
                        </tr>

                    </template>

                </table-element>

            </template>

            <template v-else>

                <span>Please create Blog Posts</span>

            </template>

            <!-- Pagination active -->
            <pagination 
                :totalpages="parseInt(totalpages)"
                :firstpageurl="firstpage"
                :otherpagesurl="adminPageUrl"
                modulename="blog"
                classname="order-4"
            />
        
        </div>

        <!-- Back To Top -->
        <back-to-top 
            idhref="header"
        />

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </section>

</template>
<script>
    import Modal from './../elements/ModalElement.vue';
    import MediaList from './../elements/MediaListElement.vue';
    import fetchData from './../../fetchData.js';
    import validation from './../../inputValidation.js';
    import Loading from './../elements/LoadingElement.vue';
    import ListMessage from './../elements/ListMessageElement.vue';
    import htmlElements from './../../htmlElements.js';
    import TableElement from './../elements/TableElement.vue';
    import Pagination from './../elements/PaginationElement.vue';
    import BackToTop from './../elements/BackToTopElement.vue';
    import ModuleAction from './../elements/ModuleActionElement.vue';
    import { QuillEditor } from '@vueup/vue-quill';
    import '@vueup/vue-quill/dist/vue-quill.snow.css';
    import BackTo from './../elements/BackToElement.vue';

    //Set Use Strict
    "use strict";


    export default{
        name: 'BlogComponent',
        props:{

            csrftolken:{
                type: String,
                required: true
            },
            blogcategorycreate:{
                type: String,
                required: true
            },
            categorylistdb:{
                type: String,
                required: true
            },
            subcategorylistdb:{
                type: String,
                required: true
            },
            blogsubcategorycreate:{
                type: String,
                required: true
            },
            blogstoreassociated:{
                type: String,
                required: true
            },
            storieslistdb:{
                type: String,
                required: true
            },
            blogmultiplefiles:{
                type: String,
                required: true
            },
            imageurl:{
                type: String,
                required: true
            },
            blogremovefile:{
                type: String,
                required: true
            },
            blogpost:{
                type: String,
                required: true
            },
            actionroutine:{
                type: String,
                required: true
            },
            blogpostlistdb:{
                type: String,
                required: true
            },
            blogposthome:{
                type: String,
                required: true
            },
            blogupdate:{
                type: String,
                required: false
            },
            blogactivepost:{
                type: String,
                required: false
            },
            blogsoftdelete:{
                type: String,
                required: false
            },
            blogrestoresoftdelete:{
                type: String,
                required: false
            },
            blogdelete:{
                type: String,
                required: false
            },
            allblogpostids:{
                type: String,
                required: false
            },
            imagestoragepath:{
                type: String,
                required: true
            },
            adminurl:{
                type: String,
                required: false
            },
            firstpage:{
                type: String,
                required: false
            },
            totalpages:{
                type: String,   
                required: false
            },
            orderurl:{
                type: String,
                required: false
            },
            searchurl:{
                type: String,
                required: false
            },
            moduledefaultindex:{
                type: String,
                required: true
            }

        },
        data: () => {

            return{

                disabled: true,
                activeclass: 'd-flex',
                btntext: 'Submit',
                filealt: '',
                title: '',
                subtitle: '',
                description: '',
                linkvideo: '',
                category: '',
                subcategory: '',
                store: '',
                storelink: '',
                formaction: '',
                keywords: '',
                shortdescription: '',
                canonicalurl: '',
                alldata: {},
                categorylist: {},
                subcategorylist: {},
                storecompanylist: {},
                filedataform: {},
                listidinputs: [],
                alertgigabyte: 1024 * 1024 * 1000 * 2,
                filedataformlist: [],
                filedataformitemlist: {},
                filedataformlistdb: [],
                filewidthheightlist: [],
                filedataimagestorender: [],
                counterrenderimg: 1,
                sendform: false,
                postcategorieschoose: [],
                postsubcategorieschoose: [],
                poststorieschoose: [],
                redirectediturl: '',
                allImages: [],
                imageIdUpdateList: [],
                buttonsaction: {},
                allmediafiles: {},
                selectaction: '',
                selectFileData: [],
                postsIds: [],
                allmediafileslocalstorage: {},
                imageIdUpdateListToDelete: [],
                authorization: true,
                allpostidsforupdate: {},
                editorData: '',
                alertmegabyte: 1024 * 1000 * 1.5,
                adminPageUrl: '',
                getCurrentPage: '',
                totalPagesModule: ''

            }

        },
        created(){

            //Set Default Value for Pages URL
            this.adminPageUrl = this.adminurl + '/admin/website/blog/page=';

            //Set Current Page Value
            this.getCurrentPage = window.location.pathname.includes('page=') ? parseInt(window.location.pathname.replace('/admin/blog/page=', '')) : 1;

            //Set Total Pages
            this.totalPagesModule = this.totalpages;

            //Get All Media Data
            this.checkLocalStorage();
            
            //Set All Data
            this.alldata = JSON.parse(this.blogpostlistdb);
         
            //Set Category List
            this.categorylist = JSON.parse(this.categorylistdb);

            //Set Subcategory List
            this.subcategorylist = JSON.parse(this.subcategorylistdb);

            //Set Stories List
            this.storecompanylist = JSON.parse(this.storieslistdb);

            //Set FormAction Route
            this.formaction = this.actionroutine;

            //Check Action Route
            if(this.formaction === "update"){

                //Set PostId List
                this.allpostidsforupdate = JSON.parse(this.allblogpostids);

                //Set Update Text
                this.btntext = "Update";

                //Set Default Data
                this.title = this.alldata[0].title;
                this.subtitle = this.alldata[0].subtitle;
                this.editorData = this.alldata[0].description;
                this.linkvideo = this.alldata[0].linkvideo !== null ? JSON.parse(this.alldata[0].linkvideo).join(", ") : "";
                this.keywords = this.alldata[0].keywords !== null ? this.alldata[0].keywords : "";
                this.shortdescription = this.alldata[0].shortdescription !== null ? this.alldata[0].shortdescription : "";
                this.canonicalurl = this.alldata[0].canonicalurl !== null ? this.alldata[0].canonicalurl : "";

                //Check Filedata
                if(this.alldata[0].files){

                    //File Data
                    let primaryimage = [];
                    let postmedia = [];

                    //Get Filedata
                    this.alldata[0].files.forEach((value) => {

                        //Get Data from Files
                        let filedata = {
                            id: value.id,
                            data: JSON.parse(value.data[0].data)
                        };

                        //Get Primary Image Data
                        if(filedata.data.fileindicated === "primaryimage"){

                            //Push Media
                            primaryimage.push(filedata);

                        }

                        //Get Postmedia Data
                        if(filedata.data.fileindicated === "postmedia"){

                            //Push Media
                            postmedia.push(filedata);

                        }

                    });

                    //Check File Alt relation
                    if(primaryimage[0] !== undefined){

                        //Set Filealt
                        this.filealt = primaryimage[0].data.filealt ? primaryimage[0].data.filealt : '';

                    }
                  
                    //Set Files List
                    this.allImages = primaryimage.concat(postmedia);

                }
               
            }

            //Set PostId and ImageIdList
            this.setPostidAndImageIdLIst();

        },
        mounted(){

            //Set Quill Content editor
            this.setEditorDescriptiondata(this.editorData);

            //Check Action Route
            if(this.formaction === "update"){

                //Enabled BTN
                this.disabled = false;

                //Render Image Structure
                this.allImages.forEach((value, index) => {

                    //Only send Object
                    for(const [indexfile, valfile] of Object.entries(value)){

                        //Show image
                        if(typeof valfile === "object"){

                            //Check primaryimage
                            if(Object.is(valfile.fileindicated, 'primaryimage')){

                                //Block Inputs When exist a primaryimage
                                document.getElementById('file').setAttribute('disabled', true);
                                //document.getElementById('filealt').setAttribute('readonly', true);

                                //Disabled Select Modal Images
                                document.querySelector('.btnselectimage').setAttribute('disabled', true);

                            }

                            //Push Valfile
                            //this.filedataformlistdb.push(valfile);

                            //Set Value for index
                            this.counterrenderimg = this.counterrenderimg + this.alldata[0].id;

                            //Render image
                            this.renderImageConditional(this.imageurl + "/" + this.alldata[0].id, [valfile], index, false, true);

                        }else{

                            //Set Image Id
                            this.imageIdUpdateList.push(valfile);

                        }

                    }
                    
                });

                //Check per Category
                this.setChoosedOption(this.alldata[0], 'category', 'category-radio-input', 'data-categoryid', this.postcategorieschoose);

                //Check per Subcategory
                this.setChoosedOption(this.alldata[0], 'subcategory', 'subcategory-radio-input', 'data-subcategoryid', this.postsubcategorieschoose);

                //Check per Stores
                this.setChoosedOption(this.alldata[0], 'stores', 'store-radio-input', 'data-storeid', this.poststorieschoose);

            }

        },
        methods:{

            getDynamicDataFromModuleAction(dynamicData){

                //Set Dynamic Data when clean search input
                if(dynamicData !== undefined && 
                typeof dynamicData === 'object' &&
                Object.values(dynamicData).length > 0){

                    //Get Default Module Data
                    this.alldata = dynamicData;

                }

            },
            getEditorDescriptionData(){

                //Other ways to get content 
                //console.log(this.$refs.quilltexteditor.editor.innerHTML);
                //console.log(this.$refs.quilltexteditor.getContents());

                //Check variable
                this.editorData = '';

                //Check content from Quill Editor Text
                if(this.$refs.quilltexteditor.getHTML() !== '<p><br></p>'){

                    //Get Content from Editor 
                    this.editorData = this.$refs.quilltexteditor.getHTML();

                }
                
                return this.editorData;
              
            },
            setEditorDescriptiondata(description){

                //Check content
                if(this.editorData){

                    //Set Content
                    this.$refs.quilltexteditor.setHTML(description);

                }

            },
            checkLocalStorage(){

                //Set All Media
                this.allmediafileslocalstorage = localStorage.getItem('medialist');

                //Check Allmedia Files LocalStorage
                if(this.allmediafileslocalstorage){

                    this.allmediafiles = JSON.parse(this.allmediafileslocalstorage);

                }

                return this.allmediafiles;

            },
            setPostidAndImageIdLIst(){

                //Check alldata length
                if(this.alldata.length > 0){

                    //Object for PostImageData
                    let postImgData = {};

                    //Get All Posts Ids
                    this.alldata.forEach((value) => {

                        //Push Post Ids
                        this.postsIds.push(value.id);

                        //Check PostId List Data
                        if(this.allpostidsforupdate.length > 0){

                            this.postsIds = this.allpostidsforupdate;

                        }

                        //Get Image Ids
                        if(value.hasOwnProperty('files')){

                            if(value.files.length > 0){

                                //Set Image Id List
                                let imageIdList = [];

                                value.files.forEach((valimg) => {

                                    //Push ImageId
                                    imageIdList.push(valimg.id);

                                    //Get Post Image Id Data
                                    postImgData = {
                                        postid: value.id,
                                        imageidlist: imageIdList
                                    };

                                });

                                //Clean Image Id List
                                imageIdList = [];

                                //Push Image Id
                                this.imageIdUpdateListToDelete.push(postImgData);

                            }

                        }
                        

                    });

                }

            },
            chooseImageFiledata(element, fileindicatedaction){

                //Set Filedata
                let filedata = {
                    fileImageId: element.target.getAttribute('data-fileid'),
                    fileindicated: fileindicatedaction,
                    fileroute: 'select', 
                    fileindexlist: 0,
                    filealt: element.target.getAttribute('data-filealt'), 
                    fileext: element.target.getAttribute('data-fileext'), 
                    filenamenew: element.target.getAttribute('data-filenamenew'),
                    filenameold: element.target.getAttribute('data-filenameold'),
                    filesrc:  element.target.getAttribute('src')
                };

                //Check imageIdList for FirstPush
                if(this.selectFileData.length === 0){

                    //Push filedata
                    this.selectFileData.push(filedata);

                    //Render Thumbnail from Select Image
                    this.renderThumbnailFromSelectImage(filedata, element, fileindicatedaction);

                }else{

                    //Check Blog Post Media
                    switch(fileindicatedaction){

                        //Primary Image
                        case 'primaryimage':

                            //Check List from primaryimage
                            let blogmedia = this.selectFileData.find(value => value.fileindicated === fileindicatedaction);

                            //Check Quantity for Primary Image
                            if(blogmedia !== undefined){

                                //Get confirmation
                                let confirmRemove = confirm('Deseja substituir a imagem ?');

                                //Remove the image to add a new one
                                if(confirmRemove){

                                    //Get Index
                                    let index  = this.selectFileData.indexOf(blogmedia);

                                    //Change blogmedia
                                    this.selectFileData.splice(index, 1);

                                    //Push filedata
                                    this.selectFileData.push(filedata);

                                    //Remove Thumbnail
                                    this.checkBaseImageThumbnail('baseimage-thumb-selectimage-primaryimage');

                                    //Render Thumbnail from Select Image
                                    this.renderThumbnailFromSelectImage(filedata, element, fileindicatedaction);

                                    return;

                                }

                            }else{

                                //Check filedata
                                if(!this.selectFileData.includes(filedata)){

                                    //console.log(fileindicatedaction);

                                    //Push filedata
                                    this.selectFileData.push(filedata);

                                    //Remove Thumbnail
                                    this.checkBaseImageThumbnail('baseimage-thumb-selectimage-primaryimage');

                                    //Render Thumbnail from Select Image
                                    this.renderThumbnailFromSelectImage(filedata, element, fileindicatedaction);

                                }

                            }

                        break;

                        //Blog PostMedia
                        default:

                            //Check List from primaryimage
                            let blogmediapost = this.selectFileData.find(value => value.fileindicated === fileindicatedaction &&
                            value.fileImageId === filedata.fileImageId);

                            //console.log(blogmediapost);
                            //console.log(filedata.fileImageId);
                            
                            //Check filedata
                            if(blogmediapost === undefined){

                                //console.log(fileindicatedaction);

                                //Push filedata
                                this.selectFileData.push(filedata);

                                //Render Thumbnail from Select Image
                                this.renderThumbnailFromSelectImage(filedata, element, fileindicatedaction);
                       
                            }else{

                                //Change blogmedia
                                //this.selectFileData.splice(index, 1);

                                //Conditional Message
                                alert('A imagem selecionada já foi adicionada');

                            }
                                                    
                        break;

                    }

                }             

            },
            chooseImage(element){

                //Set FileData from Select Imnage
                this.chooseImageFiledata(element, this.selectaction);

                //console.log(this.selectFileData);

                //Enabled Button
                this.disabled = false;

                //Closed Model
                this.hideModal('baseselectimage');

            },
            renderThumbnailFromSelectImage(filedata, element, fileindicatedaction){

                //Base Image Element - Create Element
                let divImage = htmlElements.createElement('div', {
                    class: `baseimage-thumb-selectimage-${fileindicatedaction.toLowerCase()} d-flex flex-row`,
                    data_imageid: filedata.fileImageId,
                    style: 'flex-wrap:wrap;'
                });

                //Base Image Element - Create Element
                let divBtnImage = htmlElements.createElement('div', {
                    class: `basebtn-thumb-${fileindicatedaction.toLowerCase()}-${filedata.fileImageId} d-flex flex-row me-1`,
                    data_imageid: filedata.fileImageId,
                });

                //Image Element - Create Element
                let image = htmlElements.createElement('img',  {
                    class: 'image-select-thumb',
                    data_filenameold: filedata.filenameold,
                    data_filenamenew: filedata.filenamenew,
                    data_filealt: filedata.filealt,
                    data_imageid: filedata.fileImageId,
                    alt: filedata.filealt,
                    width: '190',
                    height: '90',
                    src: element.target.getAttribute('data-thumb') === 'true' ? `${this.imagestoragepath}/${filedata.fileImageId}/thumb_${filedata.filenamenew}` : `${this.imagestoragepath}/original_default.jpg`
                });

                //Button Element
                let button = htmlElements.createElement('button',  {
                    type: 'button',
                    data_imageindex: `${filedata.fileImageId}`,
                    data_imagefilenew: `${filedata.filenamenew}`,
                    class: 'btn-remove-thumb-select btn btn-danger order-1',
                    style: "position:relative;z-index:1;width: 2rem;height: 2rem;font-size: 8pt;margin-left: -14.5%;"
                }, 'X');

                //Check Base Image Exist
                if(!document.querySelector(`.baseimage-thumb-selectimage-${fileindicatedaction.toLowerCase()}`)){

                    //Append Child
                    divImage.appendChild(divBtnImage);

                    //Append Child
                    divBtnImage.appendChild(image);

                    //Only for create thumb image
                    switch(fileindicatedaction){

                        //Primary Image
                        case 'primaryimage':

                            //Add Image Element
                            document.getElementById('file').after(divImage);

                        break;

                        //Media Image
                        default:

                            //Append Child - Button
                            divBtnImage.appendChild(button);

                            //Add Image Element
                            document.getElementById('files').after(divImage);

                        break;

                    }

                }else{

                    //Only for create thumb image
                    if(fileindicatedaction !== 'primaryimage'){

                        //Append Child - Base Image
                        document.querySelector(`.baseimage-thumb-selectimage-${fileindicatedaction.toLowerCase()}`).appendChild(divBtnImage);

                        //Append Child - Image
                        document.querySelector(`.basebtn-thumb-${fileindicatedaction.toLowerCase()}-${filedata.fileImageId}`).appendChild(image);

                        //Append Child - Button
                        document.querySelector(`.basebtn-thumb-${fileindicatedaction.toLowerCase()}-${filedata.fileImageId}`).appendChild(button);

                    }

                }

            },
            removeImageFromSelectDataList(element){

                //Check Remove Thumb Button Element
                if(element.target.nodeName === 'BUTTON' && element.target.classList.contains('btn-remove-thumb-select')){

                    //Get Parent Element
                    let parentEl = element.target.parentElement;

                    //Check and remove value from selectData list
                    if(this.selectFileData.length > 0){

                        this.selectFileData.forEach((value, index) => {

                            //Check Value by imageId
                            if(parseInt(value.fileImageId) === parseInt(parentEl.getAttribute('data-imageid'))){

                                //Remove from list
                                this.selectFileData.splice(index, 1);

                            }

                        });

                        //Remove from DOM
                        parentEl.remove();

                    }

                }

                return;

            },
            showModal(element, classname){

                //Set Select Action
                this.selectaction = element.target.getAttribute('data-imgselect');

                //Show Modal
                $(`.${classname}`).modal("show");

                return;

            },
            hideModal(classname){

                //Hide Modal
                $(`.${classname}`).modal("hide");

            },
            setChoosedOption(objectlist, objectkey, classname, attribute, chooselist){

                //Check Object
                if(objectlist.hasOwnProperty(`${objectkey}`)){

                    //Get all Keys from Object
                    let objectKeys = Object.getOwnPropertyNames(objectlist);

                    //Find object key indicated
                    let objectIndex = objectKeys.find((value) => value === objectkey);

                    //Get Object Valude
                    let objectValue = Object.getOwnPropertyDescriptor(objectlist, objectIndex);
            
                    //Get Category List
                    let allCategorys = [...document.querySelectorAll(`.${classname}`)];

                    let i = 0;

                    do{

                        //Set Id
                        let id = objectValue.value[i].id;

                        //Only Push value when is not include
                        if(!chooselist.includes(id)){

                            //Push choosed Id
                            chooselist.push(id);

                        }

                        //Set Active Choosed
                        allCategorys.forEach((value, index) => {

                            //Get Span
                            let span = [...value.children];

                            if(parseInt(span[0].getAttribute(`${attribute}`)) === id){

                                //Add Active Choosed class
                                span[0].classList.add('activechoosed');

                            }

                        });

                        i++;

                    }while(i < objectValue.value.length);

                }

            },
            getDataFromBlogPostsAssociated(postassociatedlist){

                //Check Data
                if(postassociatedlist){

                    let data = [];

                    //Check length
                    if(postassociatedlist.length > 0){

                        //Render Data
                        postassociatedlist.forEach((value) => {

                            //console.log(value.data);

                            //Get Data
                            value.data.forEach((valdata) => {

                                //console.log(valdata.name);

                                data.push(valdata.name);

                            });
                            

                        });

                        return data.join(", ");

                    }

                }

                return;
                
            },
            buttonsAction(element, action){

                //Get Index from Page List
                let parentReferId = action === 'remove' ? 
                element.currentTarget.parentElement.parentElement.parentElement.getAttribute('data-referid') : 
                element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

                //Get Values from List
                let currentItem = Object.values(this.alldata).find((value, index) => index === parseInt(parentReferId));

                //Set Action
                let action_routine = '';

                //Set Formaction
                switch(action)
                {

                    case 'softdelete':
                        this.buttonsaction.formaction = 'softdelete';
                    break;

                    case 'restore':
                        this.buttonsaction.formaction = 'restoresoftdelete';
                    break;

                    case 'edit':
                        
                        this.redirectediturl = this.blogposthome + "/" + currentItem.id;

                        window.location.replace(this.redirectediturl);

                        return;

                    break;

                    case 'remove':
                    case 'active':

                        //Set Action Routine
                        action_routine = 'blogpost';

                        //Confirm
                        let confirmAction = confirm(`Are you sure do you want to ${action} this post?`);

                        //Confirm Remove Action
                        if(confirmAction){

                            this.buttonsaction.formaction = action === 'remove' ? 'delete' : 'active';

                            //Set Active Action
                            if(action === 'active'){

                                this.buttonsaction.activeaction = element.currentTarget.textContent.trim();

                            }

                            //Get ImageIdList
                            let imageIdList = this.imageIdUpdateListToDelete.find(value => parseInt(value.postid) === parseInt(currentItem.id));

                            //Set Image Id List for remove data and att PostId List
                            if(action === 'remove'){

                                //ImageIdList Conditional
                                if(imageIdList !== undefined){

                                    //Get Index
                                    let indexImageId = this.imageIdUpdateListToDelete.indexOf(imageIdList);   

                                    //Remove Value from default imageIdUpdateListToDelete
                                    this.imageIdUpdateListToDelete.splice(indexImageId, 1);

                                    //Set imageidList
                                    this.buttonsaction.imageidlist = imageIdList.imageidlist;

                                }

                                //PostIdList Conditional
                                let postIdIndex = this.postsIds.indexOf(parseInt(currentItem.id));

                                //Remove Value from PostIdList
                                this.postsIds.splice(postIdIndex, 1);

                            }
                       

                        }else{

                            return;

                        }
                    
                    break;

                }

                //Set Page Id
                this.buttonsaction.id = currentItem.id;

                //console.log(action_routine);

                //Send Data for delete
                return this.sendData(this.buttonsaction.formaction, action_routine, this.buttonsaction);

            },
            choosedAssociatedPost(element, chooselist, inputattr){

                //Check Chose Id
                if(!chooselist.includes(parseInt(element.currentTarget.getAttribute(inputattr)))){

                    //Check Per Category or Subcategory List
                    if(inputattr === 'data-categoryid' || inputattr === 'data-subcategoryid'){

                        //Check per total
                        if(chooselist.length === 1){

                            //Informe Message
                            let confirmConditional = confirm(
                                `You can only add the post to an one ${inputattr.replace("data-", "").replace("id", "")}. Do you want to change ?`
                            );

                            //Change Choose item from Associated Post
                            if(!confirmConditional){

                                return chooselist;

                            }

                            let id = element.currentTarget.getAttribute('id');

                            //Unchecked Choosed
                            document.getElementById(`${id.replace(`${id.at(id.length - 1)}`, `${chooselist[0]}`)}`).classList.remove('activechoosed');

                            //Clean Choose List before Add New Item
                            chooselist.splice(0, 1);
                            
                            //Checked Choosed
                            element.currentTarget.classList.add('activechoosed');

                            //Push Element
                            chooselist.push(parseInt(element.currentTarget.getAttribute(inputattr)));

                            return chooselist;

                        }

                    }

                    //Checked Choosed
                    element.currentTarget.classList.add('activechoosed');

                    //Push Element
                    chooselist.push(parseInt(element.currentTarget.getAttribute(inputattr)));

                    return chooselist;

                }else{

                    //Unchecked Choosed
                    element.currentTarget.classList.remove('activechoosed');

                    //Get Index
                    let index = chooselist.indexOf(parseInt(element.currentTarget.getAttribute(inputattr)));

                    //Remove from Choose List
                    chooselist.splice(index, 1);

                }

               return chooselist;

            },
            showInput(firstclass, secondclass, element, action = 'form'){

                //Check Element
                let button = action === 'form' ? element.target : element;

                //Check Class Contains
                if(document.querySelector(`.${firstclass}`).classList.contains('d-none')){

                    //Set new TextContent
                    button.classList.remove('btn-primary');
                    button.classList.add('btn-secondary');
                    button.textContent = 'Select';

                    //Remove
                    document.querySelector(`.${firstclass}`).classList.remove('d-none');

                    //Add
                    document.querySelector(`.${secondclass}`).classList.add('d-none');

                }else{

                    //Set new TextContent
                    button.classList.remove('btn-secondary');
                    button.classList.add('btn-primary');
                    button.textContent = 'Add';

                    //Remove
                    document.querySelector(`.${secondclass}`).classList.remove('d-none');

                    //Add
                    document.querySelector(`.${firstclass}`).classList.add('d-none');


                }

            },
            showFieldsetContent(element){

                //Get Fieldsetcontent
                let fieldsetcontent = element.currentTarget.parentElement.parentElement.nextElementSibling;

                //Check Class
                if(fieldsetcontent.classList.contains('d-none')){

                    //Remove Class
                    fieldsetcontent.classList.remove('d-none');

                    //Set Text Content
                    element.currentTarget.textContent = 'Hide';

                }else{


                    //Add Class
                    fieldsetcontent.classList.add('d-none');

                    //Set Text Content
                    element.currentTarget.textContent = 'Show';

                }
                
            },
            multipleFileData(element, fileindicatedaction){

                //Check Error
                let fileError = false;

                //Set Disabled
                element.target.setAttribute('disabled', true);

                //Check Primary Image
                if(this.filedataformlist.length > 0 && fileindicatedaction === 'primaryimage'){

                    let primaryimage = this.filedataformlist.find(value => Object.is(value.fileindicated, 'primaryimage'));

                    if(primaryimage !== undefined){

                        //Set Disabled
                        //document.getElementById('filealt').setAttribute('readonly', true);

                        alert('Apenas é possível adicionar uma Imagem como Background');

                        //Clean Variable
                        element.target.value = "";

                        return;

                    }

                }

                //FileData Item Object Clean Variable
                this.filedataformitemlist = {};

                //Get Data from File
                let filedata = element.target.files;

                //Get Data from Multiple File
                [...filedata].forEach((value, index) => {

                    //Check fileSize
                    if(value.size >= Math.abs(this.alertmegabyte)){

                        alert('Please upload a smaller file up to 1MG');

                        //Enabled Input
                        element.target.removeAttribute('disabled');

                        //Disabled Submit button
                        this.disabled = true;

                        //Set Error
                        fileError = true;

                        return;

                    }

                    //Check type of the file
                    if(!value.type.includes('image')){

                        alert('Please only send image type file');

                        //Disabled Submit button
                        this.disabled = true;

                        //Set Error
                        fileError = true;

                        return;

                    }

                    //Structure File Data Object
                    this.filedataformitemlist = {
                        fileindicated: fileindicatedaction,
                        fileindex: index,
                        filename: value.name.trim(),
                    };

                    //Get Width and Height from Image
                    let reader = new FileReader();
                        reader.readAsDataURL(value);
                        reader.onload = e => {

                            const src = e.target.result;

                            const img = new Image();

                            img.onload = () => {

                                //Set FileDimension
                                let filedimension = {
                                    width: img.width,
                                    height: img.height
                                };

                                //Set File width and height
                                this.filewidthheightlist.push(filedimension);

                                return this.filewidthheightlist; 

                            };

                            img.onerror = (error) => {
                                
                                throw new Error(error)

                            };

                            img.src = src;

                        }; 
              
                    //Push Data
                    this.filedataformlist.push(this.filedataformitemlist);

                });

                //Check if exist Error and stop the script execution
                if(fileError){

                    return;

                }

                //Set Data from Multiple File and Send Filedata
                [...filedata].forEach((value, index) => {

                    //Get base64 Promise
                    let file64Promise = fetchData.toBase64(value);

                    //Get Data from Promise
                    file64Promise.then((val64) => {

                        //Check File Alt
                        let filealtname = this.filealt ? this.filealt : value.name.trim().replace(value.type.replace("image/", ""), '').toLowerCase();

                        //Structure File Data Object
                        let filedataformitemlistsend = {
                            fileindicated: fileindicatedaction,
                            fileindex: index,
                            filename: value.name.trim(),
                            type: value.type.replace("image/", ""),
                            filealt: fileindicatedaction !== 'primaryimage' ? 
                            value.name.trim().replace(value.type.replace("image/", ""), '').toLowerCase() : filealtname,
                            file64: val64,
                            filealldimensions: this.filewidthheightlist[index] ? this.filewidthheightlist[index] : null
                        };

                        //Send Data for Storage File
                        return this.sendData('insert', 'multiplefiles', filedataformitemlistsend);
                       
                    }).catch((error) => {

                        throw new Error(error);

                    });

                });


            },
            removeFile(element, fileindicatedaction){

                //Check Element
                if(element.target.nodeName === "BUTTON" &&
                  element.target.hasAttribute('data-imageindex') &&
                  element.target.hasAttribute('data-imagefilenew')
                ){

                    //Disabled Button
                    element.target.setAttribute('disabled', true);

                    //Get ImageID
                    let fileFilter = this.filedataformlistdb.find(value => value.filenamenew === element.target.getAttribute('data-imagefilenew'));

                    //Set Filedata object
                    let filedata = {
                        imgindex: element.target.getAttribute('data-imageindex'),
                        imgfilenew: element.target.getAttribute('data-imagefilenew'),
                        fileindicated: fileindicatedaction,
                        fileImageId: fileFilter !== undefined ? fileFilter.fileImageId : null 
                    };

                    //Enable Input from PrimaryImage
                    if(Object.is(filedata.fileindicated, 'primaryimage')){

                        //Enabled Inputs When exist a primaryimage
                        document.getElementById('file').removeAttribute('disabled');
                        //document.getElementById('filealt').removeAttribute('readonly');

                        //Enabled Select Modal Images
                        document.querySelector('.btnselectimage').removeAttribute('disabled');

                    }

                    //Set Post id when the formaction is update
                    if(this.formaction === "update"){

                        //Get ImageID
                        filedata.imageid = this.allImages.find(value => value.data.filenamenew === filedata.imgfilenew);

                        //Check ImageId
                        if(filedata.imageid){

                            //Get Index from Image List
                            let indexImage = this.allImages.indexOf(filedata.imageid);

                            //Remove Image from list
                            this.allImages.splice(indexImage, 1);

                            //Remove Object
                            delete filedata.imageid.data;

                            //Set Update Data
                            filedata.postid = this.alldata[0].id;
                            filedata.imageidlist = this.imageIdUpdateList;

                        }

                    }

                    //Get Input File Base
                    let inputbase = [...element.target.parentElement.parentElement.previousElementSibling.children];
                    
                    //Check Input File for Primary Image
                    if(inputbase[1].getAttribute('id') === 'file'){

                        //Check Disabled conditional
                        if(inputbase[1].hasAttribute('disabled')){

                            //Remove Attribute
                            inputbase[1].removeAttribute('disabled');

                        }

                    }

                    //console.log(filedata);

                    //Send Data for Remove File
                    return this.sendData('remove', 'multiplefiles', filedata);

                }

                return;

            },
            inputValidationMethod(validationtype, inputvalue, inputid = ''){

                //Instance Validation
                let inputValidation = new validation(validationtype, '', '');

                //Validation Method
                let validInput;

                //Set Method
                switch(validationtype)
                {
                    //Input Validation only for numbers
                    case 2:
                        validInput = inputValidation.validNameCases(validationtype, inputvalue);
                    
                    break;

                    //Input Validation All Types of data
                    case 4:
                        validInput = inputValidation.validNameCases(validationtype, inputvalue);
                    break;

                    //Email Validation
                    case 7:

                        let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
                        validInput = emailRegex.test(inputvalue);
                        
                    break;
                    
                    //URL Validation
                    case 8:
                        validInput = inputValidation.isValidUrl(inputvalue, inputid);
                    break;

                }

                return validInput;

            },
            inputValidation(element, inputid){

                //Check Value
                if(element.currentTarget.value !== ''){

                    //Check by inputid
                    switch(inputid)
                    {

                        //Title, Subtitle, keywords, filealt, shortdescription
                        case 'postcopy-title':
                        case 'postcopy-subtitle':
                        case 'filealt':
                        case 'postseo-keywords':
                        case 'postseo-shortdescription':                
                            
                            //Check Validation
                            this.disabled = this.inputValidationMethod(4, element.currentTarget.value) === true ? false : true;

                            //Check Error
                            if(this.disabled){

                                //Set Id for Error Generate
                                this.listidinputs.push(inputid)

                                //Generate Error Message
                                this.dynamicErrorMessageGenerate(this.listidinputs);

                                //Clean Variable
                                this.listidinputs = [];

                            }

                        break;

                        //description
                        case 'postcopy-description':

                            //Check Validation
                            this.disabled = this.inputValidationMethod(4, element.currentTarget.value) === true ? false : true;

                            //Check Error
                            if(this.disabled){

                                //Set Id for Error Generate
                                this.listidinputs.push(inputid)

                                //Generate Error Message
                                this.dynamicErrorMessageGenerate(this.listidinputs);

                                //Clean Variable
                                this.listidinputs = [];

                            }

                        break;

                        //Link Video
                        case 'linkvideo':   

                            //Verify Value from Input
                            let linkvideo = element.currentTarget.value.includes(',') ? element.currentTarget.value.split(",") : element.currentTarget.value;

                            //Check Type
                            if(Array.isArray(linkvideo)){

                                //console.log(linkvideo);

                                linkvideo.forEach((vallink) => {

                                    //console.log(vallink);

                                    //Check Value
                                    if(!this.inputValidationMethod(8, vallink.trim())){

                                        return this.disabled = true;

                                    }else{

                                        return this.disabled = false;

                                    }

                                });

                            }else{

                                //Check Validation
                                this.disabled = this.inputValidationMethod(8, element.currentTarget.value) === true ? false : true;

                            }

                            //Check Error
                            if(this.disabled){

                                //Set Id for Error Generate
                                this.listidinputs.push(inputid)

                                //Generate Error Message
                                this.dynamicErrorMessageGenerate(this.listidinputs);

                                //Clean Variable
                                this.listidinputs = [];

                            }

                        break;

                        //Canonical URL
                        case 'postseo-canonicalurl':
                            
                            //Check Validation
                            this.disabled = this.inputValidationMethod(8, element.currentTarget.value) === true ? false : true;

                            //Check Error
                            if(this.disabled){

                                //Set Id for Error Generate
                                this.listidinputs.push(inputid)

                                //Generate Error Message
                                this.dynamicErrorMessageGenerate(this.listidinputs);

                                //Clean Variable
                                this.listidinputs = [];

                            }

                        break;

                    }

                    return this.disabled;

                }

                return this.disabled;

            },
            renderImageConditional(sourceurl, filedataimagestorender, indexLastValuePush, removeimage = true, showthumb = false){

                //Check Images
                Object.values(filedataimagestorender).forEach((valimg, indeximg) => {

                    //Img Element
                    let image = htmlElements.createElement('img',  {
                        src: !showthumb ? `${sourceurl}/${valimg.filenamenew}` : `${sourceurl}/thumb_${valimg.filenamenew}`,
                        alt: `${valimg.filealt}`,
                        style: 'height: inherit;width: inherit;display: flex;margin-top: -20%;object-fit: fill;',
                        class: 'img-post-render order-2',
                        data_imageindex: `${indexLastValuePush}`,
                        data_imagefilenew: `${valimg.filenamenew}`,
                    });

                    //Button Element
                    let button = htmlElements.createElement('button',  {
                        type: 'button',
                        data_imageindex: `${indexLastValuePush}`,
                        data_imagefilenew: `${valimg.filenamenew}`,
                        class: 'btn-img-post-render btn btn-danger order-1',
                        style: "position:relative;z-index:1;width: 2rem;"
                    }, 'X');

                    //Div Element               
                    let div = htmlElements.createElement('div',  {
                        class: `d-flex flex-column base-img-post-render-${(indexLastValuePush + this.counterrenderimg)}`,
                        style: "width:190px;height:90px;",
                        data_imageindex: `${indexLastValuePush}`,
                        data_imagefilenew: `${valimg.filenamenew}`,
                    });

                    //Render Image
                    if(valimg.fileindicated === 'primaryimage'){

                        //Remove Data from List Image Render
                        if(removeimage){
                            filedataimagestorender.splice(indeximg, 1);
                        }
                        
                        //Append
                        document.querySelector('.primary-image-render').appendChild(div);

                        //Append Childrens
                        document.querySelector(`.base-img-post-render-${(indexLastValuePush + this.counterrenderimg)}`).appendChild(image);
                        document.querySelector(`.base-img-post-render-${(indexLastValuePush + this.counterrenderimg)}`).appendChild(button);

                        //Increments
                        this.counterrenderimg++;

                    }else{

                        //Remove Data from List Image Render
                        if(removeimage){
                            filedataimagestorender.splice(indeximg, 1);
                        }

                        //Append
                        document.querySelector('.postmedia-render').appendChild(div);

                        //Append Childrens
                        document.querySelector(`.base-img-post-render-${(indexLastValuePush + this.counterrenderimg)}`).appendChild(image);
                        document.querySelector(`.base-img-post-render-${(indexLastValuePush + this.counterrenderimg)}`).appendChild(button);

                        //Increments
                        this.counterrenderimg++;

                    }

                });

            },
            checkBaseImageThumbnail(classname){

                //Check Element
                if(document.querySelector(`.${classname}`)){

                    document.querySelector(`.${classname}`).remove();

                }

            },
            dataStructureResponse(responseObject, action){

                //Get Key and Value
                let entries = Object.entries(responseObject);

                //Response Value

                //Loop response conditional
                for(const [key, value] of entries){

                    switch(key)
                    {

                        case 'attListData':

                            //Set Boolean Value
                            this.sendform = true;

                            //Set New Att Datalist
                            switch(action){

                                //Blog Category
                                case 'category':

                                    //Set Data
                                    this.categorylist = value;

                                    //Clean Variable
                                    this.category = '';

                                    //Show Select List
                                    this.showInput('category-input', 'category-radio-base', this.$refs.btntriggercategory, 'response');

                                break;

                                //Blog Subcategory
                                case 'subcategory':

                                    //Set Data
                                    this.subcategorylist = value;

                                    //Clean Variable
                                    this.subcategory = '';

                                    //Show Select List
                                    this.showInput('subcategory-input', 'subcategory-radio-base', this.$refs.btntriggersubcategory, 'response');

                                break;

                                //Blog Store Associated 
                                case 'storiescompanys':

                                    //Set Data
                                    this.storecompanylist = value;

                                    //Clean Variable
                                    this.store = '';
                                    this.storelink = '';

                                    //Show Select List
                                    this.showInput('store-input', 'store-radio-base', this.$refs.btntriggerstoreassociated, 'response');

                                break;

                                //Multiple Files
                                case 'multiplefiles':

                                    //Clean Variable
                                    this.filealt = "";

                                    //Remove Thumbnail from Select Images
                                    this.checkBaseImageThumbnail('baseimage-thumb-selectimage-primaryimage');
                                    this.checkBaseImageThumbnail('baseimage-thumb-selectimage-postmedia');

                                    //Remove Data from Select Image Data List
                                    if(this.selectFileData.length > 0){

                                        //Remove data
                                        this.selectFileData.forEach((valimage, indeximage) => {

                                            //Check FileIndicate
                                            if(valimage.fileindicated === value.fileindicated){

                                                //Remove from Select Image Data List
                                                this.selectFileData.splice(indeximage, 1);

                                            }
                                        
                                        });
                                    
                                    }
                         
                                    //Clean Input File
                                    document.querySelector('.file').value = "";
                                    document.querySelector('.files').value = "";

                                    //Att Image Id List
                                    if(value.hasOwnProperty('newimageidlist')){

                                        //Set Image Id List
                                        this.imageIdUpdateList = value.newimageidlist;

                                        //Att Image Update default List
                                        this.filedataformlistdb.forEach((valimage, indexfile) => {

                                            if(valimage.filenamenew === value.imgfilenew){

                                                this.filedataformlistdb.splice(indexfile, 1);

                                            }

                                        });

                                    }

                                    //Check Fileroute
                                    if(value.hasOwnProperty('fileroute') && Object.is(value.fileroute, 'insert')){

                                        //Remove Disabeld
                                        document.querySelector('.file').removeAttribute('disabled');
                                        document.querySelector('.files').removeAttribute('disabled');

                                        //Enabled Inputs When exist a primaryimage
                                        //document.getElementById('filealt').removeAttribute('readonly');

                                        //Set Data
                                        this.filedataformlistdb.push(value);

                                        //List of the images to render
                                        this.filedataimagestorender.push(value);

                                        //Get Index
                                        let indexLastValuePush = this.filedataformlistdb.indexOf(value);

                                        //console.log(indexLastValuePush);

                                        //Render Image
                                        this.renderImageConditional(this.imageurl, this.filedataimagestorender, indexLastValuePush);

                                        //Clean Variable
                                        this.filedataformitemlist = {};
                                        this.filewidthheightlist = [];

                                        //Enabled Submit Button
                                        this.disabled = false;

                                    }else{

                                        //Remove Data from List
                                        this.filedataformlistdb.splice(value.fileindexlist, 1);
                                        this.filedataformlist.splice(value.fileindexlist, 1);

                                        //Remove from DOM
                                        let rendermagebase = value.fileindicated === 'primaryimage' ? 
                                        [...document.querySelector('.primary-image-render').children] 
                                        : [...document.querySelector('.postmedia-render').children];

                                        //Get Element
                                        let imgelement = rendermagebase.find(valimg => parseInt(valimg.getAttribute('data-imageindex')) === parseInt(value.fileindexlist));

                                        //Remove Element
                                        imgelement.remove();

                                        //Enabled Button
                                        let btnimg = [...document.querySelectorAll('.btn-img-post-render')];
                                        
                                        if(btnimg){

                                            btnimg.forEach((valbtn) => {

                                                if(valbtn.hasAttribute('disabled')){

                                                    valbtn.removeAttribute('disabled');

                                                }

                                            });

                                        }

                                    }

                                    //Check Media Att Sequence
                                    if(Array.isArray(value[1])){

                                        //Set New Values for Media List
                                        localStorage.setItem('medialist', JSON.stringify(value[1]));

                                        //Get All Media Data
                                        this.checkLocalStorage();

                                    }

                                break;

                                //Post Create is Default
                                default:

                                    //Set Data
                                    this.alldata = Array.isArray(value[0]) ? value[0] : value;

                                    //Set Total Pages
                                    this.totalPagesModule = this.alldata.length;

                                    //Clean Variable
                                    this.postcategorieschoose = [];
                                    this.postsubcategorieschoose = [];
                                    this.poststorieschoose = [];
                                    this.filedataformlist = [];
                                    this.filedataformlistdb = [];
                                    this.title = "";
                                    this.subtitle = "";
                                    this.description = "";
                                    this.linkvideo = "";
                                    this.filealt = "";
                                    this.selectFileData = [];
                                    this.keywords = '';
                                    this.shortdescription = '';
                                    this.postsIds = [];

                                    //Set PostId and ImageIdList
                                    this.setPostidAndImageIdLIst();

                                    //Remove images from DOM
                                    let primaryimage = [...document.querySelector('.primary-image-render').children];
                                    let rendermagebase = [...document.querySelector('.postmedia-render').children];

                                    //Remove Elements
                                    this.removeImagesFromDom(primaryimage);
                                    this.removeImagesFromDom(rendermagebase);

                                    //Get Choosed Item List
                                    //let categorycheckbox = document.querySelector('.category-radio-inputs') ? [...document.querySelector('.category-radio-inputs').children] : [];
                                    //let subcategorycheckbox = document.querySelector('.subcategory-radio-inputs') ? [...document.querySelector('.subcategory-radio-inputs').children] : [];
                                    //let storecheckbox = document.querySelector('.store-radio-inputs') ? [...document.querySelector('.store-radio-inputs').children] : [];

                                    //Remove Style
                                    /* this.removeChooseItemStyle(categorycheckbox);
                                    this.removeChooseItemStyle(subcategorycheckbox);
                                    this.removeChooseItemStyle(storecheckbox); */

                                    //Check containers
                                    let fieldsetcontent = [...document.querySelectorAll('.fieldsetcontent')];
                                    //let postassociated = [...document.querySelectorAll('.postassociated')];
                                    
                                    //Hide all containers
                                    this.hideContainers(fieldsetcontent);
                                    //this.hideContainers(postassociated);

                                    //Hide containers
                                    if(this.authorization){

                                        if(!document.querySelector('.postassociatedfieldsetcontent').classList.contains('d-none')){

                                            document.querySelector('.postassociatedfieldsetcontent').classList.add('d-none');

                                        }

                                    }

                                    //Redirect when the route is update
                                    if(this.formaction === "update"){

                                        window.location.replace(this.blogposthome);

                                    }

                                    //Check Media Att Sequence
                                    if(Array.isArray(value[1])){

                                        //Set New Values for Media List
                                        localStorage.setItem('medialist', JSON.stringify(value[1]));

                                        //Get All Media Data
                                        this.checkLocalStorage();

                                    }

                                    //Enabled Inputs When exist a primaryimage
                                    document.getElementById('file').removeAttribute('disabled');
                                    //document.getElementById('filealt').removeAttribute('readonly');

                                break;

                            }
                            
                 
                        break;

                        case 'successMessage':
                        case 'errorMessage':
                            
                            //Add active Class
                            this.$refs.responsebasemessage.classList.add(this.activeclass);
                            this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                            //Set Messages List
                            value.forEach((valmessage) => {

                                //Element for append
                                let li = `<li class="list-group item my-1">${valmessage}</li>`;

                                //Append Element
                                $(li).appendTo(this.$refs.responsebasemessage.children);

                            });
                            

                        break;

                    }

                }

                //Remove Base Response Message
                this.removeResponseMessages();

                return;

            },
            removeImagesFromDom(basedom){

                if(basedom.length > 0){

                    basedom.forEach((value) => {

                        //Remove Element
                        value.remove();

                    });

                }
            },
            removeChooseItemStyle(chooselist){

                if(chooselist.length > 0){

                    chooselist.forEach((value) => {

                        let valchildren = [...value.children];

                        if(valchildren[0].classList.contains('activechoosed')){

                            //Remove Checked
                            valchildren[0].classList.remove('activechoosed');

                        }

                    });

                }

            },
            hideContainers(containers){

                containers.forEach((value) => {

                    //Hide all
                    if(!value.classList.contains('d-none')){

                        value.classList.add('d-none');

                    }

                });

            },
            removeResponseMessages(time = 5000){

                setTimeout(function(){

                    //Remove active class
                    document.querySelector('.responsebasemessage').classList.remove('d-flex');
                    document.querySelector('.responsebasemessage').classList.remove('successmessage');
                    document.querySelector('.responsebasemessage').classList.remove('errormessage');

                    //Remove children elements
                    let ul = document.querySelector('.responsebasemessage').children;

                    [...ul[0].children].forEach((valli) => {

                        //Remove Elements
                        valli.remove();

                    });

                }, time);

            },
            sendDataAction(formaction, action){

                //Url Action
                let urlmethod = '';

                //Choose Route Action
                switch(action){

                    //Blog Category
                    case 'category':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'insert':
                                urlmethod = this.blogcategorycreate;
                            break;

                        }

                    break;

                    //Blog Subcategory
                    case 'subcategory':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'insert':
                                urlmethod = this.blogsubcategorycreate;
                            break;

                        }

                    break;

                    //Blog Store Associated
                    case 'storiescompanys':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'insert':
                                urlmethod = this.blogstoreassociated;
                            break;

                        }

                    break;

                    //Multiple Files
                    case 'multiplefiles':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'insert':
                                urlmethod = this.blogmultiplefiles;
                            break;

                            case 'remove':
                                urlmethod = this.blogremovefile;
                            break;

                        }

                    break;

                    //Blog Routines
                    case 'blogpost':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'insert':
                                urlmethod = this.blogpost;
                            break;

                            case 'update':
                                urlmethod = this.blogupdate;
                            break;

                            case 'delete':
                                urlmethod = this.blogdelete;
                            break;

                        }

                    break;

                }

                return urlmethod;

            },
            dynamicErrorMessageGenerate(listIdInputs, timeout = 5000){

                //Show Error Messages
                if(listIdInputs.length > 0){

                    //console.log(this.listidinputs);

                    //Set id for error message
                    listIdInputs.forEach((value) => {

                        //Instance Validation
                        let inputValidation = new validation(3, '', '');

                        //Set Uppercase
                        let firstLetter = value.at(0).toUpperCase();
                        let capitalizaValue = value.replace(value.at(0), firstLetter);

                        //Render Erro Message
                        inputValidation.createErrorMessageElement(value, `Please inform the correct format for ${capitalizaValue}`);

                    });

                    //Clean Variable
                    this.listIdInputs = [];

                    //console.log(this.listidinputs);

                    //Clean Error Message
                    setTimeout(function(){

                        //Clean all Error Messages
                        [...document.querySelectorAll('span.errorMessage')].forEach((value) => {

                            //Remove element
                            value.remove();

                        });

                    }, timeout);

                    //Disabled Submit
                    //this.disabled = true;

                    return this.listIdInputs;

                }

            },
            sendData(formaction, action, data = null, element = null){

                //Disabled BTN
                this.disabled = true;

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Structure Data Form
                let dataForm = {};

                //List of the Actions Create
                let actionroute = ['category', 'subcategory', 'storiescompanys'];

                //Check Action
                if(actionroute.includes(action) 
                && data !== null
                && element !== null){

                    //console.log('Input Validation');

                    //Check Data - inputValidationType 4 is default
                    let inputDataCheck = true;

                    if(!Array.isArray(data)){

                        //Check Input Value
                        inputDataCheck =  this.inputValidationMethod(4, data);

                        //Set Id Error Message
                        this.listidinputs.push(element);

                    }else{

                        data.forEach((value, index) => {

                            //Check Data
                            switch(index){

                                //Default Conditional
                                case 0:
                                    inputDataCheck =  this.inputValidationMethod(4, value);
                                break;

                                //URL conditional
                                case 1:
                                    inputDataCheck =  this.inputValidationMethod(8, value);
                                break;

                            }

                            //Set Input Id for Erro Generate Message
                            if(!inputDataCheck){

                                //Set Id Error Message
                                this.listidinputs.push(element[2]);

                                return inputDataCheck;

                            }

                        });

                    }
                    
                    //Check Input Validation
                    if(inputDataCheck){

                        //Clean Variable
                        this.listidinputs = [];

                        //Set Data formcondtional
                        dataForm.formaction = formaction;
                        
                        //Check storiescompany action
                        switch(action){

                            case 'storiescompanys':
                                dataForm.name = data[0].includes(',') ? data[0].split(",") : data[0];
                                dataForm.url = data[1].includes(',') ? data[1].split(",") : data[1];
                            break;

                            default:
                                dataForm.name = data.includes(',') ? data.split(",") : data;
                            break;

                        }

                    }else{

                        //Set Unique Values
                        this.listidinputs = [...new Set(this.listidinputs)];

                        //Generate Error Message
                        this.dynamicErrorMessageGenerate(this.listidinputs);

                        //Clean Variable
                        this.listidinputs = [];

                    }

                    //Check DataForm
                    if(dataForm.hasOwnProperty('link')){

                        //Check Name and Link
                        if(Array.isArray(dataForm.name) && !Array.isArray(dataForm.link) ||
                        !Array.isArray(dataForm.name) && Array.isArray(dataForm.link)
                        ){

                            //Error Message
                            alert('Favor confirmar dados inseridos para add nova Loja');

                            //Disabled Create Button

                            return;

                        }

                    }

                }

                //Set Description from Ckeditor
                this.description = this.editorData;

                //Required Inputs
                let requiredInputs = [
                    {
                        input: 'Post Copy - Title',
                        inputval: this.title
                    },
                    /* {
                        input: 'Post Copy - SubTitle',
                        inputval: this.subtitle
                    }, */
                    {
                        input: 'Post Copy - Description',
                        inputval: this.description
                    },
                    {
                        input: 'Post SEO - Keywords',
                        inputval: this.keywords
                    },
                    {
                        input: 'Post SEO - Description',
                        inputval: this.shortdescription
                    } 
                ];

                //Check Input for callback error message
                let checkInputRequired = requiredInputs.find(value => value.inputval === '');

                //console.log(checkInputRequired);

                //Check required inputs
                if(action === 'blogpost' && formaction === 'insert' || 
                action === 'blogpost' && formaction === 'update'
                ){

                    if(checkInputRequired !== undefined){

                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(this.activeclass);
                        this.$refs.responsebasemessage.classList.add('errormessage');

                        requiredInputs.forEach((value) => {

                            if(value.inputval === ''){

                                //Element for append
                                let li = `<li class="list-group item my-1">The ${value.input} is required.</li>`;

                                //Append Element
                                $(li).appendTo(this.$refs.responsebasemessage.children);

                            }

                        });

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Enabled BTN
                        this.disabled = false;

                        //Remove Base Response Message
                        this.removeResponseMessages();
                        
                        return;

                    }

                }
             
                //Set Route blogsoftdelete
                let method;
                let urlmethod; 

                switch(formaction)
                {

                    case 'insert':

                        method = 'POST';
                        urlmethod = this.sendDataAction(formaction, action);

                        //Set Data for correspondent action
                        switch(action)
                        {

                            //Multiple Files
                            case 'multiplefiles':

                                dataForm.files = data;

                            break;

                            //Blog Routines
                            case 'blogpost':

                                dataForm.formaction = formaction;
                                dataForm.postidlist = this.postsIds;
                                dataForm.selectfiledata = this.selectFileData;
                                dataForm.files = this.filedataformlistdb;
                                dataForm.postdata = {
                                    title: this.title.trim(),
                                    subtitle: this.subtitle.trim(),
                                    description: this.description.trim(),
                                    linkvideo: this.linkvideo.includes(',') ? this.linkvideo.split(",") : [this.linkvideo]
                                };
                                dataForm.postassociated = {
                                    category: this.postcategorieschoose,
                                    subcategory: this.postsubcategorieschoose,
                                    stories: this.poststorieschoose
                                };
                                dataForm.postseo = {
                                    keywords: this.keywords,
                                    shortdescription: this.shortdescription,
                                    canonicalurl: this.canonicalurl
                                };

                                //Set Current Page
                                dataForm.currentpage = this.getCurrentPage;

                            break;

                        }

                    break;

                    case 'update':

                        method = 'PUT';
                        urlmethod = this.sendDataAction(formaction, action);

                        //Set Data for correspondent action
                        switch(action)
                        {

                            //Blog Routines
                            case 'blogpost':

                                dataForm.postid = this.alldata[0].id;
                                dataForm.formaction = formaction;
                                dataForm.postidlist = this.postsIds;
                                dataForm.selectfiledata = this.selectFileData;
                                dataForm.imageiddefault = this.imageIdUpdateList;
                                dataForm.files = this.filedataformlistdb;
                                dataForm.postdata = {};
                                dataForm.postassociated = {
                                    category: this.postcategorieschoose,
                                    subcategory: this.postsubcategorieschoose,
                                    stories: this.poststorieschoose
                                };
                                dataForm.postseo = {};


                                //Check Title
                                if(this.title.trim() !== this.alldata[0].title && this.title.trim() !== ""){

                                    dataForm.postdata.title = this.title.trim();

                                }

                                //Check Subtitle
                                if(this.subtitle.trim() !== this.alldata[0].subtitle && this.subtitle.trim() !== ""){

                                    dataForm.postdata.subtitle = this.subtitle.trim();

                                }

                                //Check Description
                                if(this.description.trim() !== this.alldata[0].description && this.description.trim() !== ""){

                                    dataForm.postdata.description = this.description.trim();

                                }

                                //Check Value from linkvideo
                                let linkvideoval = this.linkvideo.includes(',') ? this.linkvideo.split(",") : [this.linkvideo];

                                //Set Update Value from linkvideo
                                dataForm.postdata.linkvideo = linkvideoval;
                               
                                //Check Linkvideo
                                if(this.alldata[0].linkvideo !== null){

                                    if(JSON.stringify(linkvideoval) !== this.alldata[0].linkvideo){

                                        dataForm.postdata.linkvideo = linkvideoval;

                                    }

                                }

                                //Check Keywords
                                if(this.keywords.trim() !== this.alldata[0].keywords && this.keywords.trim() !== ""){

                                    dataForm.postseo.keywords = this.keywords.trim();

                                }

                                //Check shortdescription
                                if(this.shortdescription.trim() !== this.alldata[0].shortdescription && this.shortdescription.trim() !== ""){

                                    dataForm.postseo.shortdescription = this.shortdescription.trim();

                                }

                                //Check canonicalurl
                                if(this.canonicalurl.trim() !== this.alldata[0].canonicalurl && this.canonicalurl.trim() !== ""){

                                    dataForm.postseo.canonicalurl = this.canonicalurl.trim();

                                }else{

                                    dataForm.postseo.canonicalurl = '';

                                }

                            break;

                        }

                    break;

                    case 'remove':
                    case 'delete':    

                        method = 'DELETE';
                        urlmethod = this.sendDataAction(formaction, action);

                        //Set Data for correspondent action
                        switch(action)
                        {

                            //Multiple Files
                            case 'multiplefiles':

                                dataForm.files = data;

                            break;

                            //Blog Post
                            case 'blogpost':

                                dataForm = data;

                                //Set Current Page
                                dataForm.currentpage = this.getCurrentPage;

                            break;

                        }

                    break;

                    case 'active':

                        method = 'PUT';
                        urlmethod = this.blogactivepost;

                        //Set Data
                        dataForm = data;

                        //Set Current Page
                        dataForm.currentpage = this.getCurrentPage;

                    break;

                    //Soft Delete
                    case 'softdelete':

                        method = 'PUT';
                        urlmethod = this.blogsoftdelete;
                        dataForm = data;

                        //Set Current Page
                        dataForm.currentpage = this.getCurrentPage;

                    break;

                    //Restore Soft Delete
                    case 'restoresoftdelete':

                        method = 'PUT';
                        urlmethod = this.blogrestoresoftdelete;
                        dataForm = data;

                        //Set Current Page
                        dataForm.currentpage = this.getCurrentPage;

                    break;

                }

                //console.log([method, urlmethod]);
                //console.log(Object.keys(dataForm));

                //return;

                //Check Data Form
                if(Object.keys(dataForm).length > 0){

                    //Send Data
                    let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                    //Check Response
                    response.then((value) => {

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Generate a Response
                        return this.dataStructureResponse(value, action);

                    }).catch((error) => {

                        //Show Error Message
                        alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Enabled BTN
                        this.disabled = false;

                        throw new Error(error);

                    });

                }else{

                    //Send Message
                    alert('Por favor apenas enviar dados válidos');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;

                }

                return;

            }

        },
        computed:{

            computedCategoryList(){

                return this.categorylist;

            },
            computedSubcategoryList(){

                return this.subcategorylist;

            },
            computedStoreCompanyList(){

                return this.storecompanylist;

            },
            computedAllData(){

                return this.alldata;

            },
            computedListIdInputs(){

                return this.listIdInputs;

            },
            computedFileFilesFromDB(){

                return this.filedataformlistdb;

            },
            computedFileAlt(){

                return this.filealt;

            },
            computedImageIdUpdateList(){

                return this.imageIdUpdateList;

            },
            computedSelectFiledata(){

                return this.selectFileData;

            },
            computedPostIdList(){

                return this.postsIds;

            },
            computedAllMediaFiles(){

                return this.allmediafiles; 

            },
            computedAllImages(){

                return this.allImages;

            },
            computedDisabledButton(){

                return this.disabled;

            },
            computedPostCopyDescription(){

                return this.description;

            },
            computedEditorData(){

                return this.editorData;

            },
            computedPostCategoryChoose(){

                return this.postcategorieschoose;

            }

        },
        watch:{

            computedCategoryList(){},
            computedSubcategoryList(){},
            computedStoreCompanyList(){},
            computedAllData(){},
            computedListIdInputs(){},
            computedFileFilesFromDB(){},
            computedFileAlt(){},
            computedImageIdUpdateList(){},
            computedSelectFiledata(){},
            computedPostIdList(){},
            computedAllMediaFiles(){},
            computedAllImages(){},
            computedDisabledButton(){},
            computedPostCopyDescription(){},
            computedEditorData(){},
            computedPostCategoryChoose(){}

        },
        components:{

            listMessage: ListMessage,
            loading: Loading,
            tableElement:TableElement,
            modal: Modal,
            mediaList: MediaList,
            QuillEditor,
            pagination: Pagination,
            backToTop: BackToTop,
            moduleAction: ModuleAction,
            backTo: BackTo,

        }

    }

</script>
